var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uBB38\uC790") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uBB38\\uC790",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u110C\\u1161\\u1109\\u1161\\u11AB-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    fill: "#EBEFF2",
    fillRule: "nonzero",
    x: 0.91,
    y: 3.68,
    width: 22.18,
    height: 16.63,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.83 12 12 12.89 13.17 12 12 11.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,8.22 C20.8175637,7.97699471 20.8780053,7.52256374 20.635,7.20500001 C20.3919947,6.88743629 19.9375637,6.82699472 19.62,7.07 L14.36,11.07 L15.55,11.98 L20.5,8.22 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38,7.07 C4.06243627,6.82699472 3.6080053,6.88743628 3.36500001,7.20500001 C3.12199473,7.52256374 3.18243628,7.97699471 3.5,8.22 L8.45,12 L9.64,11.09 L4.38,7.07 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.89 L10.83,12 L9.64,12.91 L11.52,14.35 C11.6368335,14.4346647 11.7758694,14.4833272 11.92,14.49 L12.08,14.49 C12.2241306,14.4833272 12.3631665,14.4346647 12.48,14.35 L14.36,12.91 L13.17,12 L12,12.89 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.55,12 L14.36,12.91 L19.62,16.91 C19.8254277,17.0671969 20.0991143,17.1028584 20.3379646,17.0035512 C20.5768149,16.904244 20.744542,16.6850552 20.7779646,16.4285512 C20.8113872,16.1720471 20.7054277,15.9171969 20.5,15.76 L15.55,12 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,15.78 C3.18243628,16.0230053 3.12199473,16.4774363 3.36500001,16.795 C3.6080053,17.1125637 4.06243627,17.1730053 4.38,16.93 L9.64,12.93 L8.45,12 L3.5,15.78 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "14.36 11.09 13.17 12 14.36 12.91 15.55 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "9.64 11.09 8.45 12 9.64 12.91 10.83 12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSms);
export default __webpack_public_path__ + "static/media/menu_sms.16de02002570ea2d73c8a667e05be847.svg";
export { ForwardRef as ReactComponent };